import * as t from "io-ts";
import nullable from "./nullable";
export const positiveIntegerT = t.refinement(t.number, (n) => Number.isInteger(n) && n > 0, "PositiveInteger");
export const cargoEquipmentRoleValues = [
    "DELIVER",
    "PICKUP",
    "RELOCATE",
    "SERVICE",
];
export const cargoEquipmentRoleT = t.union([
    t.literal("DELIVER"),
    t.literal("PICKUP"),
    t.literal("RELOCATE"),
    t.literal("SERVICE"),
]);
export const attachEquipmentToCargoT = t.strict({
    equipmentId: t.string,
    role: cargoEquipmentRoleT,
    quantity: positiveIntegerT,
    note: nullable(t.string),
    rentalId: nullable(t.string),
});
export const updateCargoEquipmentQuantityT = t.strict({
    quantity: positiveIntegerT,
});
export const cargoEquipmentLinkT = t.strict({
    id: t.string,
    cargoId: t.string,
    equipmentId: t.string,
    rentalId: nullable(t.string),
    role: cargoEquipmentRoleT,
    quantity: t.number,
    note: nullable(t.string),
    equipmentNumber: nullable(t.string),
    equipmentTypeName: nullable(t.string),
});
export const cargoEquipmentLinksT = t.array(cargoEquipmentLinkT);
//# sourceMappingURL=cargo-equipment.js.map